import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { DataTable } from 'angular-6-datatable-cc/src/DataTable';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { UserLoginComponent } from './user-login/user-login.component';
import { HttpsInterceptor } from './https-interceptor';

@NgModule({
    declarations: [
        AppComponent,
        // DataTable, 
        UserLoginComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        SharedModule
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: HttpsInterceptor, multi: true } // Register HTTPS Interceptor
    ],
    bootstrap: [AppComponent]
})

export class AppModule { }
